import type { RigaLettura } from './letture.api'

/** Formato italiano: punto per le migliaia, virgola per i decimali. */
function normalizza(v: string): string {
  return v.trim().replace(/\./g, '').replace(',', '.')
}

export function interpretaIncollato(
  testo: string,
  mesi: readonly number[],
  contatoreId: number,
): RigaLettura[] {
  const righe = testo.split(/\r?\n/).filter((r) => r.trim() !== '')

  return righe.slice(0, mesi.length).map((riga, i) => {
    const valore = normalizza(riga)
    if (!/^-?\d+(\.\d+)?$/.test(valore)) {
      throw new Error(`Contenuto non numerico alla riga ${i + 1}: "${riga.trim()}"`)
    }
    return { contatoreId, mese: mesi[i]!, valore }
  })
}
